import React from 'react';
import { ItpSubbieApiProvider } from '@api/ApiProvider';
import { renderWithParents } from '@ascension/components/render-helper';
import { ItpSubbieErrorBoundary } from '@itp-subbie/ErrorBoundaries';
import {
  ItpSignupBanner,
  ItpSignupBannerNoNoticeboard,
} from '@itp-subbie/features/itp-signup-banner';
import { ItpQuotePage } from '@itp-subbie/pages/ItpQuotePage';
import { CurrencyInfoContextProvider } from '@shared';
import { LegacyFileManagerParams } from '@shared/FileUploader/types';
import { ItpSubbieContextProvider } from '@itp-subbie/context';

renderWithParents<
  {
    stageId: string;
    rfqId: string;
    openSignupModal: string;
    stageCountryId: string;
  } & LegacyFileManagerParams
>(
  <ItpSubbieErrorBoundary />,
  <ItpSubbieApiProvider />,
  <CurrencyInfoContextProvider />,
)('itp-quote-submission-container')(
  ({
    stageId,
    rfqId,
    fileManagerKey,
    fileManagerEndpoint,
    fileManagerLocale,
    openSignupModal,
    stageCountryId,
  }) => (
    <ItpSubbieContextProvider
      stageId={parseInt(stageId)}
      rfqId={parseInt(rfqId)}
      fileManagerKey={fileManagerKey}
      fileManagerEndpoint={fileManagerEndpoint}
      fileManagerLocale={fileManagerLocale}
      openSignupModal={openSignupModal === '1'}
    >
      <ItpQuotePage stageCountryId={parseInt(stageCountryId)} />
    </ItpSubbieContextProvider>
  ),
);

renderWithParents(<ItpSubbieErrorBoundary />)('itp-side-banner')(() => <ItpSignupBanner />);
renderWithParents<{ slug: string; rfqId: string; rfqHash: string }>(<ItpSubbieErrorBoundary />)(
  'itp-side-banner-no-noticeboard',
)(({ slug, rfqId, rfqHash }) => (
  <ItpSignupBannerNoNoticeboard slug={slug} rfqId={parseInt(rfqId)} rfqHash={rfqHash} />
));
